import { render, staticRenderFns } from "./HowItWorksSwap.vue?vue&type=template&id=69718928&scoped=true"
import script from "./HowItWorksSwap.vue?vue&type=script&lang=js"
export * from "./HowItWorksSwap.vue?vue&type=script&lang=js"
import style0 from "./HowItWorksSwap.vue?vue&type=style&index=0&id=69718928&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69718928",
  null
  
)

export default component.exports